import React from 'react';
import { Modal, Loader } from 'rsuite';

const ModalLoader = () => (
  <Modal size="xs" show>
    <Modal.Body>
      <Loader content="searching item..." center vertical />
      <br />
    </Modal.Body>
  </Modal>
);

export default ModalLoader;
